<template>
  <div class="box5">
    <h1 class="title-txt">课程优势突出&nbsp;&nbsp;对标企业需求</h1>
    <div class="content common-animation">
      <div>
        <p>新</p>
        <h1>紧跟市场热点，课程全新升级</h1>
        <p>瞄准企业需求不讲过时内容，每年至少一次课程大更新。</p>
      </div>
      <div>
        <p>热</p>
        <h1>聚焦行业热门岗位</h1>
        <p>不贪大不贪多，做细重效，让学员少走弯路！</p>
      </div>
      <div>
        <p>强</p>
        <h1>百万粉丝大V参与课研</h1>
        <p>人均7-10年专业运营经验，高标准师资团队。课程内容更有保障！</p>
      </div>
      <div>
        <p>高</p>
        <h1>就业率远超竞品</h1>
        <p>因为聚焦，所以卓越，2022全年平均就业率95%以上。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box5 {
  width: 100%;
  background: #fefbf3;
  overflow: hidden;
  padding-bottom: 58px;
  .title-txt {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1a0400;
    line-height: 40px;
    margin: 80px 0 59px;
    text-align: center;
  }
  .content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    div {
      margin-bottom: 30px;
      position: relative;
      padding-left: 128px;
      box-sizing: border-box;
      padding-right: 30px;
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      p:nth-child(1) {
        position: absolute;
        top: 16px;
        left: 17px;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 36px;
      }
      h1 {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 600;
        margin-top: 6px;
        line-height: 26px;
      }
      p:nth-child(3) {
        margin-top: 17px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #665552;
        line-height: 36px;
      }
    }
    div:nth-child(1) {
      background: url("../../../assets/coursePage/newMedia/box5/1.png")
        no-repeat;
      background-size: cover;
      width: 661px;
      height: 194px;

      h1 {
        color: #ff3912;
      }
    }
    div:nth-child(2) {
      background: url("../../../assets/coursePage/newMedia/box5/2.png")
        no-repeat;
      background-size: cover;
      width: 661px;
      height: 157px;

      h1 {
        color: #ff6c00;
      }
    }
    div:nth-child(3) {
      background: url("../../../assets/coursePage/newMedia/box5/3.png")
        no-repeat;
      background-size: cover;
      width: 661px;
      height: 187px;

      h1 {
        color: #dca207;
      }
    }
    div:nth-child(4) {
      background: url("../../../assets/coursePage/newMedia/box5/4.png")
        no-repeat;
      background-size: cover;
      width: 661px;
      height: 187px;

      h1 {
        color: #05b9a9;
      }
    }
  }
}
</style>
